var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.106 6.477"}},[_c('path',{attrs:{"d":"M.106 1.177l5.191 5.189a.35.35 0 00.512 0l5.186-5.189a.35.35 0 000-.512l-.556-.556a.35.35 0 00-.512 0L5.553 4.485 1.179.111a.351.351 0 00-.512 0L.106.668a.351.351 0 000 .509z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }